"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Geodes_exports = {};
__export(Geodes_exports, {
  default: () => Geodes_default
});
module.exports = __toCommonJS(Geodes_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 200 200",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0 8C0 3.58173 3.58172 0 8 0H192C196.418 0 200 3.58172 200 8V192C200 196.418 196.418 200 192 200H8C3.58173 200 0 196.418 0 192V8Z",
      fill: "#46A6DE"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M177.635 92.2908C173.348 87.252 176.967 86.857 178.927 90.7716C179.006 90.9336 179.166 91.045 179.345 91.0501L183.154 91.2121C183.503 91.2273 183.762 90.8729 183.638 90.5437C179.445 79.428 155.72 77.0732 173.737 98.1196C182.112 107.909 172.456 110.83 174.315 102.211C174.37 101.968 174.156 101.74 173.906 101.73L168.398 102.414C168.088 102.399 167.824 102.627 167.779 102.93L167.68 103.624C165.596 115.621 180.243 118.346 183.453 109.083C185.567 103.001 181.125 96.3877 177.635 92.2908ZM89.6445 99.5477C89.6495 96.7675 88.9466 94.2759 87.6055 92.1895C86.1049 89.8296 84.2454 88.8168 82.0319 88.9991C79.8185 89.1814 78.0337 90.4677 76.6329 92.7922C75.3766 94.8735 74.7534 97.1372 74.7683 99.6338C74.7833 102.151 75.4414 104.379 76.7076 106.389C78.1235 108.617 79.8932 109.808 82.0768 109.959C84.2604 110.106 86.095 109.134 87.5906 106.85C88.9266 104.814 89.6395 102.348 89.6445 99.5477ZM96.0506 80.7092C100.144 84.8466 103.095 91.5717 102.97 100.201C102.856 108.617 99.6849 115.105 95.4275 119.232C90.9357 123.592 86.3193 124.524 80.7956 123.526C75.91 122.584 71.812 120.113 68.2575 115.429C65.0619 111.205 63.2273 106.116 63.1326 100.029C63.0329 94.124 64.7927 89.0396 68.1279 84.7301C71.6974 80.1319 75.9648 77.4277 81.0449 76.4199C86.9774 75.2805 91.7832 76.3794 96.0506 80.7092ZM119.227 88.908C119.462 91.992 119.646 95.3748 119.686 98.7881C119.731 102.576 119.611 106.394 119.422 109.843C134.971 108.369 133.725 90.2854 119.227 88.908ZM106.335 123.268C105.947 123.202 105.677 122.827 105.722 122.432C106.036 119.662 107.123 109.24 106.998 99.0767C106.879 89.1561 106.011 80.0762 105.747 77.4834C105.707 77.0732 105.991 76.7035 106.395 76.6478C156.871 70.1353 152.285 131.325 106.335 123.268ZM62.1505 114.654C61.986 114.026 61.4775 113.56 60.8394 113.479C58.3218 113.145 54.0294 112.527 50.4799 111.838C50.1957 109.18 50.0462 106.642 50.0063 104.257C52.7582 104.44 56.218 104.592 58.586 104.698C59.4734 104.738 60.1913 103.999 60.1414 103.098C60.0816 101.948 60.0467 100.723 60.0467 99.6743C60.0467 98.7577 60.0816 97.7043 60.1364 96.727C60.1913 95.8458 59.5183 95.0963 58.6458 95.0811L50.3752 94.9798C50.6195 92.4731 50.9635 90.2601 51.3174 88.4016L61.0139 86.9786C61.7816 86.8671 62.4297 86.3304 62.6939 85.5859L65.0918 78.8659C65.3611 78.1164 64.7578 77.3416 63.9751 77.4378C60.2661 77.8733 51.133 79.3368 44.5274 81.2409C43.7647 81.4587 43.1565 82.0107 42.8424 82.75C41.2271 86.543 36.7404 99.2995 40.6239 116.406C40.8183 117.272 41.4864 117.966 42.3389 118.179C48.9743 119.819 59.254 121.632 62.9781 122.265C63.6212 122.377 64.1446 121.764 63.9552 121.126C63.4367 119.384 62.7288 116.857 62.1505 114.654ZM37.3735 82.3955C10.2384 82.3955 9.8047 115.262 31.1718 115.262C33.0113 115.262 33.8738 115.069 35.0703 114.76C35.6835 114.603 36.2368 114.502 35.9776 113.423C34.3773 106.779 34.8808 100.044 35.7931 96.0382C35.9078 95.542 35.8629 95.2584 34.9456 95.1318C34.0234 95.0052 28.7838 94.9039 27.3779 95.1672C27.029 95.2331 26.7548 95.4964 26.6401 95.8357C26.2862 96.9194 26.1366 98.707 26.2114 99.6844C26.2413 100.074 26.5155 100.398 26.8894 100.49C27.019 100.525 27.368 100.56 27.7718 100.591C27.5624 102.946 27.5325 105.64 27.8117 108.455C19.6507 105.883 22.3527 87.1507 35.0404 89.8145C35.3046 89.8702 35.5389 89.617 35.6236 89.3688C36.0324 88.1484 37.2189 84.0211 37.7374 82.8513C37.8471 82.6082 37.6427 82.3955 37.3735 82.3955ZM166.359 111.393C166.159 112.714 165.915 113.996 165.347 116.664C165.137 116.897 149.199 120.614 144.633 121.389C143.476 121.587 142.499 120.493 142.813 119.348C147.609 102.029 146.313 93.4809 141.188 80.2534C140.734 79.0836 141.706 77.853 142.928 78.0607C147.335 78.8152 156.228 80.9168 160.112 81.9702C161.353 82.3044 162.405 83.1298 163.048 84.2591C163.711 85.4289 164.529 86.9532 164.978 88.1281C165.212 88.7409 164.733 89.3992 164.09 89.3739L155.326 88.7358C155.934 90.5994 156.443 92.7618 156.732 95.2179L163.138 95.2229C163.572 95.2229 163.941 95.5318 164.02 95.9623C164.16 96.7016 164.359 97.9018 164.474 99.0919C164.584 100.267 164.579 101.406 164.554 102.115C164.539 102.551 164.225 102.915 163.806 102.991C161.428 103.427 159.459 103.518 156.807 103.645C156.807 103.645 156.802 103.65 156.797 103.66C156.577 106.369 156.174 108.942 155.685 111.256V111.261C155.625 111.55 155.855 111.818 156.144 111.793C158.188 111.605 162.096 111.104 165.247 110.354C165.88 110.213 166.458 110.749 166.359 111.393Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8 1H192V-1H8V1ZM199 8V192H201V8H199ZM192 199H8V201H192V199ZM1 192V8H-1V192H1ZM8 199C4.13401 199 1 195.866 1 192H-1C-1 196.971 3.02944 201 8 201V199ZM199 192C199 195.866 195.866 199 192 199V201C196.971 201 201 196.971 201 192H199ZM192 1C195.866 1 199 4.13401 199 8H201C201 3.02944 196.971 -1 192 -1V1ZM8 -1C3.02944 -1 -1 3.02944 -1 8H1C1 4.13401 4.13401 1 8 1V-1Z",
      fill: "#7A7562"
    }
  )
);
const SvgGeodes = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Geodes_default = SvgGeodes;
